<template>
  <a-row class="oa-upload">
    <a-col :xs="6" :sm="4" style="text-align:right;line-height: 30px;">附件：
    </a-col>
    <a-col :xs="14" :sm="10" style="max-width: 100%; line-height: 30px; overflow: hidden;">
      <a-upload class="upload-list-inline" :class="canEdit?'':'upload-list-detail'" name="file" :remove="handleRemove" :beforeUpload="beforeUpload" accept=".png,.jpg,.jpeg,.ppt,.pptx,.pdf,.doc,.docx,.xls,.xlsx,.xlsm,.xltx,.xltm,.xlsb,.xlam" :multiple="true" :fileList="fileList" :defaultFileList="fileList" listType="picture">
        <a-button class="upload-btn blueBorderBtn" v-if="canEdit" icon="plus">添加附件</a-button>
      </a-upload>
    </a-col>
  </a-row>
</template>
<script>
import { uploadApi } from '../services/CommonService.js';
export default {
  props: {
    layout: Object,
    canEdit: Boolean,
    params: Array,
    defaultFileNone: Boolean,
  },
  data() {
    return {
      fileList: [],
      init: true,
    };
  },
  methods: {
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
      let params = this.setFileObj();
      this.$emit('changed-fields', params);
    },
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 <= 10;
      let hasSameNameFile = false;

      if (!isLt10M) {
        this.$Message.error('单文件不能大于 10MB！');
        return false;
      }
      this.fileList.forEach(item => {
        if (item.name === file.name) {
          hasSameNameFile = true;
          this.$Message.warning('该文件名与已上传文件名相同');
        }
      });

      if (isLt10M && !hasSameNameFile) {
        this.handleChange(file);
      }

      return false;
    },
    handleChange(file) {
      const fileInfo = new FormData();
      fileInfo.append('fileInfo', file);
      uploadApi(fileInfo).then(res => {
        if (res.status === 'success') {
          file.file_key = res.data.annexKey;
          file.uid = res.data.annexKey;
          file.url = res.data.url;
          file.thumbUrl = this.checkIsImage(file.name)
            ? '/images/file-image.svg'
            : '/images/file-default.svg';
          this.fileList = [...this.fileList, file];
          let params = this.setFileObj();
          this.$emit('changed-fields', params);
          this.$Message.success(`${file.name}上传成功！`);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    setFileObj() {
      let fileObj = {};
      fileObj[this.layout.field] = this.fileList.map(item => {
        return {
          id: item.file_key,
          name: item.name,
          url: item.url,
        };
      });
      return fileObj;
    },
    checkIsImage(filepath) {
      const extStart = filepath.lastIndexOf('.');
      const ext = filepath.substring(extStart, filepath.length).toUpperCase();
      let isImage = false;
      if (
        ext != '.BMP' &&
        ext != '.PNG' &&
        ext != '.GIF' &&
        ext != '.JPG' &&
        ext != '.JPEG'
      ) {
        isImage = false;
      } else {
        isImage = true;
      }
      return isImage;
    },
  },
  watch: {
    params: {
      handler(val) {
        if (this.defaultFileNone && this.init) {
          this.fileList = [];
          this.init = false;
        } else if (this.init) {
          let fileArr = val.map(item => {
            return {
              uid: item.id, // 必须配置不可删除
              file_key: item.id,
              name: item.name,
              url: item.url,
              thumbUrl: this.checkIsImage(item.name)
                ? '/images/file-image.svg'
                : '/images/file-default.svg',
            };
          });
          this.fileList = fileArr;
          this.init = false;
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style lang="less">
//在common.less
</style>